import { createSlice } from "@reduxjs/toolkit";

const initialStoreState = {
  adType: [],
  brand: [],
  category: [],
  country: [],
  dtLevel: [],
  feature: [],
  keyword: [],
  language: [],
  orientation: [],
  region: [],
  stage: [],
  subBrand: [],
  creative: [],
  brandCollab: [],
  year: [],
  mediaType: [],
  filters: [],
  selectedCreativeIds: [],
};

const storeSlice = createSlice({
  name: "data",
  initialState: initialStoreState,
  reducers: {

    store(state, action) {
      const {
        adType,
        brand,
        brandCollab,
        category,
        country,
        dtLevel,
        feature,
        keyword,
        language,
        orientation,
        region,
        stage,
        subBrand,
        creative,
        year,
        mediaType,
        filters,
        selectedCreativeIds
      } = action.payload;

      if (adType) {
        state.adType = adType;
      }
      if (brand) {
        state.brand = brand;
      }
      if (category) {
        state.category = category;
      }
      if (country) {
        state.country = country;
      }
      if (dtLevel) {
        state.dtLevel = dtLevel;
      }
      if (feature) {
        state.feature = feature;
      }
      if (keyword) {
        state.keyword = keyword;
      }
      if (language) {
        state.language = language;
      }
      if (orientation) {
        state.orientation = orientation;
      }
      if (region) {
        state.region = region;
      }
      if (stage) {
        state.stage = stage;
      }
      if (subBrand) {
        state.subBrand = subBrand;
      }
      if (creative) {
        state.creative = creative;
      }
      if (brandCollab) {
        state.brandCollab = brandCollab;
      }
      if (year) {
        state.year = year;
      }
      if (mediaType) {
        state.mediaType = mediaType;
      }
      if (filters) {
        state.brandCollab = brandCollab;
      }
      if (selectedCreativeIds) {
        state.selectedCreativeIds = selectedCreativeIds;
      }
    },

    storeClean(state, action) {
      const {
        adType,
        brand,
        category,
        country,
        dtLevel,
        feature,
        keyword,
        language,
        orientation,
        region,
        stage,
        subBrand,
        creative,
        year,
        brandCollab,
        mediaType,
        filters,
        selectedCreativeIds
      } = action.payload;
      if (adType) {
        state.adType = initialStoreState.adType;
      }
      if (brand) {
        state.brand = initialStoreState.brand;
      }
      if (category) {
        state.category = initialStoreState.category;
      }
      if (country) {
        state.country = initialStoreState.country;
      }
      if (dtLevel) {
        state.dtLevel = initialStoreState.dtLevel;
      }
      if (feature) {
        state.feature = initialStoreState.feature;
      }
      if (keyword) {
        state.keyword = initialStoreState.keyword;
      }
      if (language) {
        state.language = initialStoreState.language;
      }
      if (orientation) {
        state.orientation = initialStoreState.orientation;
      }
      if (region) {
        state.region = initialStoreState.region;
      }
      if (stage) {
        state.stage = initialStoreState.stage;
      }
      if (subBrand) {
        state.subBrand = initialStoreState.subBrand;
      }
      if (creative) {
        state.creative = initialStoreState.creative;
      }
      if (brandCollab) {
        state.brandCollab = initialStoreState.brandCollab;
      }
      if (year) {
        state.year = initialStoreState.year;
      }
      if (mediaType) {
        state.mediaType = initialStoreState.mediaType;
      }
      if (filters) {
        state.filters = initialStoreState.filters;
      }
      if (selectedCreativeIds) {
        state.selectedCreativeIds = initialStoreState.selectedCreativeIds;
      }
    },

    cleanCreative(state) {
      state.creative = initialStoreState.creative
    },

    logout(state) {
      // Preserve mediaType filter - it's separate and should not be cleared
      const preservedMediaType = state.mediaType;
      state.adType = initialStoreState.adType;
      state.brand = initialStoreState.brand;
      state.brandCollab = initialStoreState.brandCollab;
      state.category = initialStoreState.category;
      state.country = initialStoreState.country;
      state.dtLevel = initialStoreState.dtLevel;
      state.feature = initialStoreState.feature;
      state.keyword = initialStoreState.keyword;
      state.language = initialStoreState.language;
      state.orientation = initialStoreState.orientation;
      state.region = initialStoreState.region;
      state.stage = initialStoreState.stage;
      state.subBrand = initialStoreState.subBrand;
      state.year = initialStoreState.year;
      state.mediaType = preservedMediaType; // Preserve mediaType filter
      state.filters = initialStoreState.filters;
      state.selectedCreativeIds = initialStoreState.selectedCreativeIds; // Clear selected creative IDs on logout
    },
  },
});

export const storeActions = storeSlice.actions;
export default storeSlice.reducer;
